export async function getProductsIndicator() {
  return new Promise((resolve) => {
    const products = 4000;
    setTimeout(() => {
      resolve(products);
    }, 1500);
  });
}
